import { render, staticRenderFns } from "./DeleteClientHandler.vue?vue&type=template&id=a98bccc4&scoped=true"
import script from "./DeleteClientHandler.vue?vue&type=script&lang=js"
export * from "./DeleteClientHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98bccc4",
  null
  
)

export default component.exports